"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-twelve/sections/blogSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogSection612sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" | "3s" | "4s" */
    dataWowDuration: string;
    /** Detected variants: "17" | "24" | "01" | "05" */
    div0Text: ReactNode;
    /** Detected variants: "Nov" | "Dec" */
    span0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/blog/blog-lab-1.jpg" | "/Templates/Doccure/img/blog/blog-lab-2.jpg" | "/Templates/Doccure/img/blog/blog-lab-3.jpg" | "/Templates/Doccure/img/blog/blog-lab-4.jpg" */
    src: string;
    /** Detected variants: "The Importance of Blood Tests in Preventive Care" | "Understanding Your Lab Results: A Guide" | "Advancements in Genetic Testing: What You Need." | "How Lab Technology is Revolutionizing Care" */
    link0Text: ReactNode;
    /** Detected variants: "Discover how routine blood tests can uncover potential health risks before..." | "Learn how to interpret lab results and discuss them effectively with your..." | "Explore the latest innovations in genetic testing and their impact on..." | "Examine the role of advanced lab technologies in enhancing patient..." */
    p0Text: ReactNode;
    /** Detected variants: "Diagnostics" | "Education" | "Genetics" | "Technology" */
    span0Span0Text: ReactNode;
    /** Detected variants: "col-xl-6 col-lg-12" */
    className?: string;
    /** Detected variants: "blog-item-twelve wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "blog-img" */
    div0ClassName2?: string;
    /** Detected variants: "blog-date" */
    div0ClassName3?: string;
    /** Detected variants: "blog" */
    alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "blog-details" */
    div1ClassName?: string;
    /** Detected variants: "blog-content" */
    div0ClassName4?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    href?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "blog-footer" */
    div1ClassName2?: string;
    /** Detected variants: "badge" */
    span0ClassName?: string;
};
export type HomeTwelveBlogSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection612sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection612sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1Div0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection612sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Latest From Our" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Health Blogs" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    /** Default: "Discover our most trusted & essential test packages to meet every individual’s needs." */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    blogSection612s: BlogSection612sItem[];
    blogSection612sItemWrapper?: (item: BlogSection612sItem, content: ReactNode) => ReactNode;
    blogSection612sRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogSection612sLinkVisible?: boolean;
    blogSection612sLinkRenderer?: (item: BlogSection612sItem, defaultNode: ReactNode) => ReactNode;
    blogSection612sImageVisible?: boolean;
    blogSection612sImageRenderer?: (item: BlogSection612sItem, defaultNode: ReactNode) => ReactNode;
    blogSection612sH3Visible?: boolean;
    blogSection612sH3Renderer?: (item: BlogSection612sItem, defaultNode: ReactNode) => ReactNode;
    blogSection612sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection612sItem) => Partial<ComponentProps<typeof SmartLink>>);
    blogSection612sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection612sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogSection612sH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection612sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTwelveBlogSectionGenerated: FC<HomeTwelveBlogSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Latest From Our",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Health Blogs",
    sectionDiv0Div0P0PText = "Discover our most trusted & essential test packages to meet every individual’s needs.",
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0H30H3Props,
    divDiv0Div1Div0H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    blogSection612s,
    blogSection612sItemWrapper,
    blogSection612sRenderer,
    blogSection612sLinkVisible,
    blogSection612sLinkRenderer,
    blogSection612sImageVisible,
    blogSection612sImageRenderer,
    blogSection612sH3Visible,
    blogSection612sH3Renderer,
    blogSection612sLinkProps,
    blogSection612sImageProps,
    blogSection612sH3Props,
}) => {
    return (
        <section className="blog-section-twelve section">
            <div className="container">
                <div className="section-header section-header-twelve text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            <span className="text-primary">{sectionDiv0Div0H20Span0SpanText}</span>
                            {" "}
                        </h2>
                    ))}
                    <p className="description">{sectionDiv0Div0P0PText}</p>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        blogSection612s,
                        (item: BlogSection612sItem) => (
                            <div className={item.className ?? "col-xl-6 col-lg-12"} key={item.key}>
                                <div className={item.div0ClassName ?? "blog-item-twelve wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "blog-img"}>
                                        {renderItemNode(blogSection612sImageVisible, blogSection612sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "blog"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-one"} {...(typeof blogSection612sImageProps === "function" ? blogSection612sImageProps(item) : (blogSection612sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        <div className={item.div0ClassName3 ?? "blog-date"}>
                                            {item.div0Text}
                                            <span>{item.span0Text}</span>
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-details"}>
                                        <div className={item.div0ClassName4 ?? "blog-content"}>
                                            {renderItemNode(blogSection612sH3Visible, blogSection612sH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof blogSection612sH3Props === "function" ? blogSection612sH3Props(item) : (blogSection612sH3Props ?? {}))} {...(typeof divDiv0Div1Div0H30H3Props === "function" ? divDiv0Div1Div0H30H3Props(item) : (divDiv0Div1Div0H30H3Props ?? {}))}>
                                                    {renderItemNode(blogSection612sLinkVisible, blogSection612sLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "all_routes.blogDetails"} {...(typeof blogSection612sLinkProps === "function" ? blogSection612sLinkProps(item) : (blogSection612sLinkProps ?? {}))} {...(typeof divDiv0Div1Div0H30Link0LinkProps === "function" ? divDiv0Div1Div0H30Link0LinkProps(item) : (divDiv0Div1Div0H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                    ))}
                                                </h3>
                                            ))}
                                            <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                        </div>
                                        <div className={item.div1ClassName2 ?? "blog-footer"}>
                                            <span className={item.span0ClassName ?? "badge"}>{item.span0Span0Text}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                        blogSection612sItemWrapper,
                        blogSection612sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeTwelveBlogSectionGenerated;
